export const DEFAULT_TABLE_OPTIONS = {
  enableStickyHeader: true,
  enableValueFormatting: true,
  rowVirtualization: {
    enabled: true,
  },
};
